import ConfirmarExclusao from './ConfirmarExclusao'
import DialogConfirmar from './DialogConfirmar'
import { Actions } from './DialogGuideActions'
import { Content } from './DialogGuideContent'
import { Root } from './DialogGuideRoot'
import { Title } from './DialogGuideTitle'

/**
 * @example
 * import Dialog from 'global/guides/Dialog'
 *
 * return <Dialog.Root>
 *      <Dialog.Title></Dialog.Title>
 *      <Dialog.Content></Dialog.Content>
 *      <Dialog.Actions>
 *          <Dialog.Actions.SecondaryButton />
 *          <Dialog.Actions.PrimaryButton />
 *      </Dialog.Actions>
 *  </Dialog.Root>
 *
 * @example
 * // Confirmação: a árvore acima já montada.
 * return <Dialog.ConfirmarExclusao
 *      permissao={['delete', 'Locais']}
 *      loading={isLoading}
 *      onConfirm={handleSubmit}
 *      title="Realmente deseja excluir o local?"
 *  />
 */
const Dialog = {
    Root,
    Title,
    Content,
    Actions,
    Confirmar: DialogConfirmar,
    ConfirmarExclusao,
}

export default Dialog
